module.exports = __webpack_public_path__ + "static/custom-events3-b6e853f11852583e71806d0c5811d609.png";